import { Pipe, PipeTransform } from '@angular/core';
import { getGpsCoordinatesLabel, GpsCoordinates } from '@insite-group-ltd/insite-teams-model';

@Pipe({ name: 'gpsCoordinatesLabel' })
export class GpsCoordinatesLabel implements PipeTransform {
    transform(gpsCoordinates: GpsCoordinates): string {
        return gpsCoordinates ? getGpsCoordinatesLabel(gpsCoordinates) : undefined;
    }
}
